import {BaseApi} from './api/BaseApi';
import {BaseValidatedClass} from './BaseValidatedClass';
import {ExternalGalleryImageSelectCallback} from './ExternalImageLibrary';
import {ImmutableHtmlNode} from './modifications/ImmutableNode';

interface ExternalImageLibraryTabMap {
  getName(): string;
  openImageLibraryTab(_container: HTMLElement, _onImageSelectCallback: ExternalGalleryImageSelectCallback): void;
}

export class ExternalImageLibraryTab extends BaseValidatedClass implements ExternalImageLibraryTabMap {
  public api!: BaseApi;
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof ExternalImageLibraryTabMap)[] = ['getName', 'openImageLibraryTab'];

  constructor() {
    super(ExternalImageLibraryTab.REQUIRED_METHODS, ExternalImageLibraryTab);
  }

  /**
   * @description Returns the translated name/label for the tab
   * @returns Translation key or text to display as tab label
   */
  public getName(): string {
    throw new Error('Method getName() must be implemented by the subclass');
  }

  /**
   * @description Opens the external image library tab and provides a container for rendering
   * @param _container - DOM element container where the external library UI should be rendered
   * @param _onImageSelectCallback - Callback to invoke when an image is selected
   * @param _selectedNode - (Optional) Selected node for which the gallery is being opened
   */
  public openImageLibraryTab(_container: HTMLElement, _onImageSelectCallback: ExternalGalleryImageSelectCallback, _selectedNode?: ImmutableHtmlNode): void {
    throw new Error('Method openImageLibraryTab() must be implemented by the subclass');
  }
}
